import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from "@angular/common";
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../store';
import * as fromRootStore from '../../reducers';
//import {ToWord} from '';
//import { toWords } from 'npm-number-to-word';
import { PrintColumnModel } from './print.model';
import { CommonService, ServiceWalkInService, SubscribeService } from '../../services/index';
import { ServiceWalkInModel } from '../../model';
@Component({
	selector: 'modal-content',
	templateUrl: './print.preview.html'
})
export class PrintPreview implements OnInit {

	_printdata: any[] = [];
	data:any;
	mod:any;
	status = 'printed';
	billDetails:any;
	@Output() printEvent = new EventEmitter();
	@Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
	@Input() set printData(val: any[]) {
		this._printdata = val;
		if (val['type'] == 'HVGeneral') {
			this.generateHVPrint(val['clientDet']);
		}
		else if (val['type'] == 'HVRecheckup') {
			this.generateHVRecheckupPrint(val['clientDet']);
		}
		else if (val['type'] == 'HVShowroom') {
			this.generateHVShowroomPrint(val['clientDet']);
		}
		else if (val['type'] == 'Spare Bill' || val['type'] == 'Sales Bill' || val['type'] == 'HV Bill List' || val['type'] == 'SOA Bill List' || val['type'] == 'HV' || val['type'] == 'SOA' || val['type'] == 'Advance' || val['type'] == 'Pre-Booking Bill') {
			this.genarateSalesBill(val);
		} else if (val['type'] == 'Cash Receipt') {
			this.genarateCashreceipt(val);
		} else if (val['type'] == 'HV/SOA Challan Out') {
			this.genarateHVSOAOUTBill(val);
		} else if (val['type'] == 'EMI Bill') {
			this.generateemiDetail(val);
		} else if (val['type'] == 'Testing Bill') {
			this.generateTestDetail(val);
		} else if (val['type'] == 'Service Walk In') {
			this.generateServiceDetail(val);
		} else if (val['type'] == 'Service Ackowledment') {
			this.generateServiceAckowledment(val);
		}
		else if (val['type'] == 'Transfer Challan Out' || val['type'] == 'Transfer Challan In') {
			this.genarateHVSOAOUTBill(val);
		}
		else {
			this.generatePrintContent();
		}
		this.setCssPath(val['type']);
	}

	get printData(): any[] {
		return this._printdata;
	}

	constructor(public printModalRef: BsModalRef, public toasterService: ToasterService, public datePipe: DatePipe, private store: Store<fromRootStore.State>, private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService) {

	}

	ngOnInit(): void {
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			this.usertype = auth['usertype'];
		});
	}
	setCssPath(type) {
		let that = this;
		//TO GET PRINT CSS PATH NAME 
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) {
				let cssPathName = auth['printCssName'];
				if (type == 'hvPrint') {
					cssPathName = auth['hvPrintCssPath'];
				}
				document.getElementById('cssPathName')['href'] = cssPathName;
			}
		});
	}

	columns: PrintColumnModel[] = [];
	printStr: string = "";
	colids: any[] = [];
	totrows: any[] = [];
	usertype: any;
	generatePrintContent() {
		//console.log(this._printdata);
		/*_.forEach(this._printdata, (item, key) => {
			//console.log(key, item);
			if(key.toString()=="title"){
				this.setHeader(item, 'center');
			}

			if(key.toString()=="subTitle"){
				this.setSubHeader(item, 'center');
			}

			if(key.toString()=="columns"){
				this.columns = item;
				this.setColumns(item);
			}

			if(key.toString()=="rows"){
				this.setRows(item);
			}
		});*/

		let title = this._printdata['title'],
			subTitle = this._printdata['subTitle'],
			columns = this._printdata['columns'],
			rows = this._printdata['rows'],
			printTime = this._printdata['printTime'];

		this.columns = columns;

		this.setHeader(title, 'center', printTime);

		if (subTitle && subTitle != '') {
			this.setSubHeader(subTitle, 'center');
		}

		this.setColumns(columns);
		this.setRows(rows);

		$('#printContent').html(this.printStr);
	}

	setHeader(title: string, align: string, printTime: any) {
		let cls = 'hdr1';
		cls += align == 'center' ? ' txtaligncenter' : '';
		this.printStr += '<div class="' + cls + '">' + title;

		if (printTime) {
			let todayDt = this.datePipe.transform(new Date(), 'dd/MM/yyyy hh:mm a');
			this.printStr += '<span class="printTime">Date:- ' + todayDt + '</span>';
		}

		this.printStr += '</div>';
	}

	setSubHeader(content: any, align: string) {
		if (typeof content === "object") {
			this.printStr += '<table class="subHdrTable"><tr>';
			_.forEach(content, (str, key) => {
				if (str != '')
					this.printStr += '<td width="5%" align="right">' + key + ' : </td><td width="5%" align="left">' + str + '</td>';
			});
			this.printStr += '</tr><table>';
		} else {
			let contSplt = content.split(",");

			this.printStr += '<table class="subHdrTable"><tr>';
			_.forEach(contSplt, (obj, key) => {
				this.printStr += '<td width="5%">' + obj + '</td>';
			});
			this.printStr += '</tr><table>';
		}

		/*let cls = 'hdr1';
		cls += align=='center'?' txtaligncenter':'';
		this.printStr += '<div class="'+cls+'">'+content+'</div>';*/
	}

	setColumns(columns: PrintColumnModel) {
		this.printStr += '<table width="100%" border="0" cellspacing="0" cellpadding="0" class="txt12"><thead><tr>';

		_.forEach(columns, (item, key) => {
			let prop = item['prop'],
				name = item['name'],
				width = item['width'],
				align = item['align'],
				sum = item['sum'],
				isPrint = item['isPrint'];

			if (isPrint != false) {
				let cls = '';
				cls += align != '' ? ' rmp txtalign' + align : '';

				this.printStr += '<th class="tdr tdb lmp tblbdr3 ' + cls + '">' + name + '</th>';

				if (sum) {
					this.totrows[prop] = 0;
				}

				this.colids.push(prop);
			}
		});

		this.printStr += '</tr></thead>';
	}

	setRows(rows: any) {
		_.forEach(rows, (item, key) => {
			//let rowObj = _.pick(item, this.colids);
			this.printStr += '<tr>';
			_.forEach(this.columns, (rowobj, ind) => {
				let prop = rowobj['prop'],
					name = rowobj['name'],
					width = rowobj['width'],
					align = rowobj['align'],
					type = rowobj['type'],
					sum = rowobj['sum'],
					isPrint = rowobj['isPrint'],
					value = item[prop] ? item[prop] : '';

				if (isPrint != false) {
					let cls = '';
					cls += align != '' ? ' rmp txtalign' + align : '';

					if (value != '' && type == "number") {
						value = parseInt(value);
					}

					if (value != '' && type == "float") {
						let decimal = rowobj['decimal'] != undefined ? rowobj['decimal'] : 2;
						value = parseFloat(value).toFixed(decimal);
					}

					if (sum && value != '') {
						let sumfld = rowobj['sumfld'] != undefined ? rowobj['sumfld'] : prop,
							sumval = item[sumfld] != undefined ? item[sumfld] : value;
						this.totrows[prop] += parseFloat(sumval);
					}

					this.printStr += '<td class="tdr tdb lmp ' + cls + '">' + value + '</td>';
				}

			});
			this.printStr += '</tr>';
		});
		//console.log(this.totrows);
		if (_.keys(this.totrows).length > 0) {
			this.printStr += '<tr>';
			let sumtitle = this._printdata['sumtitle'],
				colInd = 0;
			_.forEach(this.columns, (rowobj, ind) => {
				let prop = rowobj['prop'],
					align = rowobj['align'],
					type = rowobj['type'],
					isPrint = rowobj['isPrint'],
					value = this.totrows[prop] ? this.totrows[prop] : '';
				if (isPrint != false) {
					let cls = '';
					cls += align != '' ? ' rmp txtalign' + align : '';

					if (value != '' && type == "float") {
						let decimal = rowobj['decimal'] != undefined ? rowobj['decimal'] : 2;
						value = parseFloat(value).toFixed(decimal);
					}

					if (colInd == 0 && value == '') {
						value = sumtitle;
						colInd++;
					}

					this.printStr += '<td class="tdr tdb lmp txtBold ' + cls + '">' + value + '</td>';
				}
			});
			this.printStr += '</tr>';
		}
	}

	onPrint() {
		let that = this;
		let data = {
			status:that.status,
			billDetails:this._printdata['rows'],
			print_type :this._printdata['type']
		};
		if(this._printdata['type'] == "Service Ackowledment"){
		swal({
            title: 'Are you sure to Print the Bill?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Print',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
           that.mod = that.serviceWalkInService
                .addPrintStatus(data)
                .then(function(res: any) {
                    if (res.success) {
						//console.log(res.message);
                        swal('SUCCESS', res.message, 'success');
						that.printEvent.emit();
                    } else {
						console.log(res.message);
                        swal('ERROR', res.message, 'error');
                    }
                }).catch(function(error: any) {
                    //let res = JSON.parse(error._body);
                    //swal('ERROR', res.message, 'error');
                    console.log(error);
                });

        }, function(dismiss) {

        })
		}else{
			that.printEvent.emit();
		}
	}
	generateHVPrint(pageDet) {
	
		let hvPrintStr = '',
			ClientNo = pageDet['client_no'],
			ClientName = pageDet['client_name'] ? pageDet['client_name'].toUpperCase() : '',
			Mobile = pageDet['mobile'],
			Appdate = pageDet['app_date'],
			dispdate = pageDet['disp_date'],
			//Disdate = new Date(Appdate);
			//Disdate.setDate(Disdate.getDate() + 1);
			splitdate = dispdate.split('-');

		let Deldate = splitdate[0] + '/' + splitdate[1] + '/' + splitdate[2],
			Address = pageDet['address'] ? pageDet['address'].toUpperCase() : '',
			Profession = pageDet['profession'] ? pageDet['profession'].toUpperCase() : '',
			Email = pageDet['email_id'],
			HaUser = pageDet['ha_user'],
			DrConsulted = pageDet['dr_consulted'],
			Relation = pageDet['relation'] ? String(pageDet['relation']).toUpperCase() : '',
			Attender = pageDet['name'] ? pageDet['name'].toUpperCase() : '',
			Model = pageDet['model_name'] ? pageDet['model_name'].toUpperCase() : '',
			Branch = pageDet['branch'] ? pageDet['branch'].toUpperCase() : '',
			Age = pageDet['age'],
			Reference = pageDet['reference'] ? pageDet['reference'].toUpperCase() : '',
			Combination = pageDet['visitor_name'] ? pageDet['visitor_name'].toUpperCase() : '';

		hvPrintStr += `<div class="modal-header">
    <h4 class="modal-title pull-left"><center>Home Visit Details</center></h4>
</div>
<div class="modal-body">

    <div>
        <label><b>COMBINATIONS:</b>${Combination}</label><label style="float:right;margin-right:30%"><b>OUT TIME:</b> </label>
		<br>
		<br>
		<label><b>APPOINTMENT DATE: </b>${Deldate}</label><label style="float:right;margin-right:30%"><b>IN TIME:</b> </label>
		<br>
		<br>
    </div>
    <table border="1" width="45%" cellspacing="0" cellpadding = "0" style="float: left; margin-right:1em; width:55%;">
        <thead style="border-right-width:5px">
            <tr>
                 <th style="width:20%;padding-left:10px;">
                    Client Name
                </th>


               <td style="width:80%;padding-left:10px;">
                    ${ClientName}
                </td>
            </tr>


            <tr>

                <th style="width:20%;padding-left:10px;">
                    Age
                </th>

                <td style="width:80%;padding-left:10px;">
                    ${Age} <span style="border-left:1px solid;border-right:1px solid;margin-left: 5em;
padding-left: 10px;
padding-right: 10px;"><b>Client No : </b>${ClientNo}</span>
                </td>
            </tr>
            <tr>

                <th style="width:20%;padding-left:10px;">
                    Phone No
                </th>

                <td style="width:80%;padding-left:10px;">
                    ${Mobile}
                </td>
            </tr>
            <tr>

                <th style="width:20%;padding-left:10px;">
                    Profession
                </th>

                <td style="width:80%;padding-left:10px;">
                    ${Profession}
                </td>
            </tr>
            <tr>

                <th style="width:20%;padding-left:10px;">
                    Address
                </th>

                <td style="width:80%;padding-left:10px;">
                    ${Address}
                </td>
            </tr>
        </thead>
    </table>

    <table border="1" width="45%" cellspacing="0" cellpadding = "0" style="width:35%;">
        <thead>
            <tr>
                <th style="width:30%;padding-left:10px;">
                    Caller Name
                </th>


                <td style="width:70%;padding-left:10px;">
                    ${Attender}
                </td>
            </tr>


            <tr>

               <th style="width:30%;padding-left:10px;">
                    Relation
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${Relation}
                </td>
            </tr>
            <tr>

               <th style="width:30%;padding-left:10px;">
                    Phone No
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${Mobile}
                </td>
            </tr>
            <tr>

                <th style="width:30%;padding-left:10px;">
                    Profession
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${Profession}
                </td>
            </tr>
            <tr>

               <th style="width:30%;padding-left:10px;">
                    Reference
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${Reference}
                </td>
            </tr>
            <tr>

               <th style="width:30%;padding-left:10px;">
                    Branch
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${Branch}
                </td>
            </tr>
            <tr>

                <th style="width:30%;padding-left:10px;">
                    Dr.Consult (YES/NO)
                </th>

                <td style="width:70%;padding-left:10px;">
                    ${DrConsulted}
                </td>
            </tr>
        </thead>
    </table>

</div>
<div class="modal-body">
    <label><b>HV NO :</b></label>
	<br>
	<br>
    <label><b>E-MAIL ID :</b>${Email}</label>
	<br>
	<br>
    <label><b>APPOINTMENT TIME :</b></label>
	<br>
	<br>
    <label><b>ALREADY H.AID USED :</b>${HaUser}</label>
	<br>
	<br>
    <label><b>MODEL (BTE/CIC) :</b>${Model}</label>
	<br>
	<br>
    <label> <b>BTE PRIZING DETAILS: BTE STARTING FROM 13,000/-(MACHINE RATE DIFFERS BASED UPON THE HEARING LOSS) </b></label>
	<br>
	<br>
	<label><b>SERVICE:</b></label>
    <input type="checkbox">Excellent
    <input type="checkbox">Good
    <input type="checkbox">Average
    <input type="checkbox">Bad
  <br>
   <br> 
        <label><b>COUNCELLING:</b></label>
		<input type="checkbox">Excellent
		<input type="checkbox">Good
		<input type="checkbox">Average
		<input type="checkbox">Bad
		<br>
		<br>

    <label><b>USAGE AND ALLOWANCE</b></label>
        <br><br>
        <input type="checkbox">ON/OFF<checkbox>
        <input type="checkbox">Battery</checkbox>
        <input type="checkbox">Wearing Practice</checkbox>
        <input type="checkbox">Care and Maintenence</checkbox><br>
		<br>
		<br>
        <input type="checkbox">Dry Kit
		<input type="checkbox">Tips/Molds
		<input type="checkbox">Volume Control
		<input type="checkbox">Programming Button
        <br>
        <br>

    <label><b>MODE OF PAYMENT:</b></label>
    <label>CASH/CHEQUE</label>
		<br>
		<br>
        <label>SOLD/ADVANCE/TRIAL</label>
		<br>
		<br>
        <label>TRAVELLING ALLOWANCE:</label>
		<br>
		<br>
		<label>IN AND OUT TIME:</label>
		<br>
		<br>
        <label style="float: right;"><b>CUSTOMER SIGNATURE<b></label>
</div>
<div class="modal-footer">
</div>`;
		$('#printContent').html(hvPrintStr);
	}
	generateHVRecheckupPrint(pageDet) {
		let hvPrintStr = '',
			ClientNo = pageDet['client_no'],
			ClientName = pageDet['client_name'] ? pageDet['client_name'].toUpperCase() : '',
			Mobile = pageDet['mobile'],
			Address = pageDet['address'] ? pageDet['address'].toUpperCase() : '',
			Profession = pageDet['profession'] ? pageDet['profession'].toUpperCase() : '',
			Email = pageDet['email_id'],
			AppDate = pageDet['disp_date'],
			HaUser = pageDet['ha_user'],
			DrConsulted = pageDet['dr_consulted'],
			Relation = pageDet['relation'] ? String(pageDet['relation']).toUpperCase() : '',
			Attender = pageDet['name'] ? pageDet['name'].toUpperCase() : '',
			Model = pageDet['model_name'] ? pageDet['model_name'].toUpperCase() : '',
			Branch = pageDet['branch'] ? pageDet['branch'].toUpperCase() : '',
			Age = pageDet['age'],
			Reference = pageDet['reference'] ? pageDet['reference'].toUpperCase() : '',
			Combination = pageDet['visitor_name'] ? pageDet['visitor_name'].toUpperCase() : '',
			Months = pageDet['recheckup_months'];


		hvPrintStr += `<div class="modal-header">
	<h4 class="modal-title pull-left"><center>HV RECHECKUP</center></h4>
	<br>
	<br><br><br>
	</div>
	<div>
	</div>
    <div class="modal-body">
    <div>
    <label><b>COMBINATIONS:</b>${Combination}</label>
		<br>
		<br>
		<label><b>APPOINTMENT DATE:</b>${AppDate}</label>
		<br>
		<br>
    <label><b>CLIENT NAME:</b>${ClientName}</label>
	<br>
	<br>
	<label><b>CLIENT PHONE NO:</b>${Mobile}</label>
	<br>
	<br>
	<label><b>ADDRESS:</b>${Address}</label>
	<br>
	<br>
	<label><b>CLIENT EMAIL ID:</b>${Email}</label>
	<br>
	<br>
	<label><b>OCCUPATION:</b>${Profession}</label>
	<br>
	<br>
	<label><b>ACTIVITY:</b>${Reference}</label>
	<br>
	<br>
	<label><b>RE-CHECKUP:</b>${Months}</label>
	<br>
	<br>
	<label><b>MACHINE NAME:</b>${Model}</label>
	<br>
	<br>
	<label><b>ARE YOU SATISFIED WITH HV TECHNICIAN /AUDIOLOGIST RESPONSE:</b></label>
	<input type="checkbox">YES
<input type="checkbox">NO
	<br>
	<br>
	<label><b>CUSTOMER SERVICE RATING: </b></label>
	<input type="checkbox">5
<input type="checkbox">4
<input type="checkbox">3
<input type="checkbox">2
<input type="checkbox">1
	<br>
	<br>
	<label><b>GENERAL COMMENT:</b></label>
	<br>
	<br>
	<br>
	<br>
	<br>
	<br><br><br><br><br><br>
	<label><b>TRAVELLING EXPENSE:</b></label>
	<label style="float: right;"><b>CUSTOMER SIGNATURE</b></label>
	<br>
	<br>
</div>

</div>
<div class="modal-footer">

</div>`
		$('#printContent').html(hvPrintStr);
	}
	generateHVShowroomPrint(clientObj) {
		let hvPrintStr = '',
			ClientNo = clientObj['client_no'],
			ClientName = clientObj['client_name'],
			Mobile = clientObj['mobile'],
			Hamodel = clientObj['model_name'],
			Haamount = clientObj['ha_amount'],
			Advamount = clientObj['advance_amount'],
			Totamount = clientObj['total_amount'],
			Billno = clientObj['bill_no'],
			Combination = clientObj['visitor_name'],
			BalanceAmt = Totamount - Advamount,
			Deldate = clientObj['disp_date'],
			Address = clientObj['address'];

		hvPrintStr += `<div class="modal-header">
	<h4 class="modal-title pull-left"><center>HV/SHOWROOM DELIVERY</center></h4>
	<br>
	<br>
	</div>
	<div>
	</div>
    <div class="modal-body">
    <div>
    <label><b>APPOINTMENT DATE:</b>${Deldate}</label>
	<br>
	<br>
	<label><b>CLIENT NAME: ${ClientName} </b></label>
	<br>
	<br>
	<label><b>PHONE:</b>${Mobile}</label>
	<br>
	<br>
	<label><b>ADDRESS:</b>${Address}</label>
	<br>
	<br>
	<label><b>APPOINTMENT TIMING:</b></label>
	<br>
	<br>
	<h4><b>IF DELIVERY HEARING AID DETAILS:</b></h4>
	<table border="1" width="80%" cellspacing="0" cellpadding = "0">
	<thead>
		<tr>
			<th width="25%">MACHINE NAME AND MODEL</th>
			<th width="20%">HA MRP PRIZE</th>
			<th width="20%">TOTAL AMOUNT</th>
			<th width="20%">ADVANCE VALUE</th>
			<th width="20%">BALANCE VALUE</th>
			<th width="15%">SPARE(FREE/AMOUNT)</th>
		</tr>
	</thead>
	<tbody>
	<tr>
	<td>${Hamodel}</td>
	<td>${Haamount}</td>
	<td>${Totamount}</td>
	<td>${Advamount}</td>
	<td>${BalanceAmt}</td>
	<td></td>
	</tr>
	</tbody>
	</table>
	<br><br>
	<label><b>IN AND OUT TIME:</b></label>
	<br>
	<br>
	<label><b>ADVANCE BILL NO:</b>${Billno}</label>
	<br>
	<br>
	<label><b>BALANCE:</b>${BalanceAmt}</label>
	<br>
	<br>
	<label><b>COMBINATIONS:</b>${Combination}</label>
	<br>
	<br>
	<label><b>TRAVELLING ALLOWANCE:</b></label>
	<br><br>
	<label><b>TRAVELLING EXPENSE:</b></label>
	<br><br><br><br><br>
	<label style="float: right;"><b>CUSTOMER SIGNATURE</b></label>
	<br>
	<br>
</div>

</div>
<div class="modal-footer">

</div>`
		$('#printContent').html(hvPrintStr);
	}
	generateemiDetail(pageDet) {
		let title = pageDet['title'],
			subTitle = pageDet['subTitle'].toUpperCase();
		let align = 'center';
		let cls = 'hdr1';
		let type: any = pageDet;
		let typename = type.rows;
		var det = typename.det;
		/* 		let cgst = parseFloat(typename.cgstper).toFixed(0);
				let sgst = parseFloat(typename.sgstper).toFixed(0);
				let cgstamt = parseFloat(typename.cgstamt).toFixed(2);
				let sgstamt = parseFloat(typename.sgstamt).toFixed(2); */
		let gst = {};
		let arr = [];
		for (let i of det) {
			if (i.free_item != 'Yes') {
				let gper = i.gstper + '';
				if (!gst[gper]) {
					gst[gper] = {
						gstper: gper,
						gstamt: 0//parseFloat(i.gstamt)
					}
				}
				gst[gper].gstamt += parseFloat(i.gstamt);
			}
		}
		for (let i of Object.keys(gst)) {
			arr.push(gst[i]);
		}
		var showgst = true;
		for (let i of arr) {
			if (i.gstper == 0) {
				showgst = false;
			} else {
				showgst = true;
			}
		}
		console.log(arr);
		let gstset = gst['gstper'];
		const C = '#1a3a8f';
		const G = '#16a34a';
		this.printStr = '';
		this.printStr += `<div style="font-family:Arial,sans-serif;font-size:13px;color:#000;max-width:780px;margin:0 auto;padding:8px 16px;display:flex;flex-direction:column;min-height:240mm;">`;

		// Header: full-width gradient, logo left 25%, tagline top-right inside gradient
		this.printStr += `<div style="background:linear-gradient(to top,white 20%,${C} 20%,${C} 55%,forestgreen 50%,forestgreen 85%,white 80%,white 100%);margin:0 -16px;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:flex;align-items:flex-start;justify-content:space-between;">`;
		this.printStr += `<img src="assets/images/logo-white-new.png" height="100" style="width:25%;display:block;margin-left:90px;">`;
		this.printStr += `<div style="padding:0px 25px 0 0;font-size:13px;font-style:italic;color:${G};font-weight:700;">Get Your Life Back</div>`;
		this.printStr += `</div>`;

		// Branch address
		this.printStr += `<div style="text-align:right;font-size:13px;color:#333;font-weight:bold;margin:4px 0 8px 0;line-height:1.5;max-width:55%;margin-left:auto;">${typename.comp_address}</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Two-column: client info (left, padded down) | bill info (right) with HERO ELECTRONIC
		this.printStr += `<div style="display:flex;justify-content:space-between;gap:24px;margin:8px 0 10px 0;">`;
		this.printStr += `<div style="flex:1;font-size:13px;line-height:2;padding-top:30px;">`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">To Mr/Mrs</span>${typename.client_name}</div>`;
		this.printStr += `<div style="display:flex;"><span style="font-weight:bold;min-width:100px;flex-shrink:0;">Address</span><span>${typename.address}</span></div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">Mobile No</span>${typename.mobile}</div>`;
		this.printStr += `</div>`;
		this.printStr += `<div style="min-width:260px;font-size:13px;line-height:1.9;">`;
		this.printStr += `<div style="font-size:22px;font-weight:900;color:#000;margin-bottom:6px;line-height:1.1;">HERO ELECTRONIC</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">GST Number</span>${typename.tinno || ''}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Number</span>${typename.bill_id}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Type</span>${typename.type}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Date</span>${typename.disp_date}</div>`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Bill title
		this.printStr += `<div style="text-align:center;font-size:15px;font-weight:bold;color:${C};letter-spacing:2px;margin:8px 0 12px 0;">EMI BILL</div>`;

		// Items table
		this.printStr += `<table class="sb-print-table" style="width:100%;border-collapse:collapse;font-size:13px;">`;
		this.printStr += `<thead><tr>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;width:10%;border-top:2px solid ${C};border-bottom:2px solid ${C};">QTY</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:75%;border-top:2px solid ${C};border-bottom:2px solid ${C};">PARTICULARS</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:right;font-weight:bold;width:15%;border-top:2px solid ${C};border-bottom:2px solid ${C};">AMOUNT</th>`;
		this.printStr += `</tr></thead><tbody>`;
		for (let i of typename.det) {
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;width:10%;">${i.machine_qty}</td>`;
			this.printStr += `<td style="padding:8px 6px;width:75%;">${i.machine_name} - Serial No (${i.serial_no})</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:right;width:15%;">${i.machine_price}</td>`;
			this.printStr += `</tr>`;
		}
		this.printStr += `</tbody></table>`;

		// Totals
		this.printStr += `<div style="display:flex;justify-content:flex-end;margin:8px 0 4px 0;">`;
		this.printStr += `<table class="sb-print-table" style="font-size:13px;border-collapse:collapse;min-width:280px;">`;
		this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;">Gross Total:</td><td style="padding:4px 0;text-align:right;min-width:80px;">${typename.gross_total}</td></tr>`;
		if (typename.less_amount > 0) {
			this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;">Less Amount:</td><td style="padding:4px 0;text-align:right;">${typename.less_amount}</td></tr>`;
		}
		this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;">Discount Amount:</td><td style="padding:4px 0;text-align:right;">${typename.discount_amount}</td></tr>`;
		this.printStr += `<tr style="border-top:2px solid ${C};border-bottom:2px solid ${C};">`;
		this.printStr += `<td style="padding:6px 20px 6px 0;text-align:right;font-weight:bold;font-size:14px;">Grand Total:</td>`;
		this.printStr += `<td style="padding:6px 0;text-align:right;font-weight:bold;font-size:14px;">${typename.amount}</td>`;
		this.printStr += `</tr>`;
		if (showgst !== false && typename.amount != 0) {
			for (let i of arr) {
				if (i.gstper != 0) {
					const gstc = i.gstper / 2;
					this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;">GST ${i.gstper}% (CGST ${gstc}% + SGST ${gstc}%):</td><td style="padding:4px 0;text-align:right;">${i.gstamt}</td></tr>`;
				}
			}
		}
		this.printStr += `</table></div>`;

		// Terms and Conditions | Signature
		this.printStr += `<div style="display:flex;align-items:flex-start;margin:4px 0 10px 0;margin-top:auto;">`;
		this.printStr += `<div style="flex:1;font-size:12px;"><div style="font-weight:bold;font-size:13px;margin-bottom:4px;">Terms and Conditions</div>Service Undertaken / Goods Once Sold cannot be Return/Exchanged</div>`;
		this.printStr += `<div style="min-width:35%;text-align:center;font-size:14px;color:${C};font-weight:600;font-style:italic;">Signature</div>`;
		this.printStr += `</div>`;

		// Footer contact row
		this.printStr += `<div style="display:flex;justify-content:space-between;font-size:14px;color:#111;font-weight:600;padding:8px 0;border-top:2px solid ${C};border-bottom:2px solid ${C};margin:8px 0 4px 0;">`;
		this.printStr += `<span>hello@soundsgood.in</span>`;
		this.printStr += `<span>www.soundsgood.in</span>`;
		this.printStr += `<span>Toll Free 1800 270 196</span>`;
		this.printStr += `</div>`;

		// Branch numbers — dark navy background with white text
		this.printStr += `<div style="background:${C};font-size:10px;text-align:center;color:#fff;line-height:1.9;padding:6px 8px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">`;
		this.printStr += `<b>Madurai:</b> 98430 62988 &bull; <b>Madurai Anna Nagar:</b> 84899 78679 &bull; <b>Madurai By-Pass:</b> 84899 78670 &bull; <b>Coimbatore:</b> 84899 78677, <b>Tirunelveli:</b> 97867 86006 &bull; <b>Theni:</b> 84899 78616 &bull; <b>Tirupur:</b> 84899 78679 &bull; <b>Nagarcoil:</b> 84899 78690 &bull; <b>Tuticorin:</b> 84899 78620, <b>Palayamkottai:</b> 97867 86004 &bull; <b>Coimbatore Peelamedu:</b> 84899 78627, <b>Ramanathapuram:</b> 84899 78689`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;
		$('#printContent').html(this.printStr);
	}

	billHeader(pageDet) {
		let branch_short_name = '';
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) {
				branch_short_name = auth['branch_short_name'];
			}
		});

		// let title = pageDet['title'],
		let subTitle = '';
		if(pageDet.rows && (pageDet.rows.transaction_type == 'Exchange' || pageDet.rows.transaction_type == 'Replacement' || pageDet.rows.transaction_type == 'Trial')) {
			subTitle = pageDet.rows.transaction_type.toUpperCase() + ' - ';
		}
		subTitle += pageDet['subTitle'].toUpperCase();
		let align = 'center';
		let cls = 'hdr1';
		let type: any = pageDet;
		let typename = type.rows;
		// var det = typename.det;
		cls += align == 'center' ? ' txtaligncenter' : '';
		this.printStr += '<div class="txt10">';
		this.printStr += '<div style="float:right;font_weight:bold"><b>Email</b> : hello@soundsgood.in</div>';
		this.printStr += '<div><span style="font_weight:bold;font-size: 10px;text-align: center;float:left;left: 25%;position: absolute;top: 22px;">Unit of <span style="color: #D22B2B;font-size:20px;"><b>hero</b></span> <span style="color: #87CEEB;font-size:18px;"><i> electronic</i></span></span><span  style="float:right;clear:right;font_weight:bold"> <b>Web site</b> : www.soundsgood.in </span></div>';
		this.printStr += '<br>';
		this.printStr += '<div style="margin-top: 10px; background: linear-gradient(to top,white 20%,#2b2c87 20%, #2b2c87 55%,forestgreen 50%, forestgreen 85%,white 80%, white 100%);"><img src = "assets/images/logo-white-new.png" height="100" width="200" class="img"></div>';
		this.printStr += '<div style="font-weight:normal;font-size:10px;left: 25%;position: absolute;margin-top: -1%">' + typename.comp_address + ', Ph ' + typename.phoneno + ', Mobile ' + typename.comp_mobile + '</div>'
		this.printStr += '<div style="text-align: center;margin-top: 1%;"><span class="com_title">' + subTitle + '</span></div>';
		this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>To Mr/Mrs</b> :' + typename.client_name + '</div><br>';
		this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Address</b> :'+ typename.address+'</div><br>';
		if(pageDet['subTitle'] == 'Service Bill' && this.usertype != 'Super_Admin' && this.usertype != 'Admin'){
			this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Mobile No</b> :'+ typename.disp_mobile +'</div><br>';
		} else {
			this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Mobile No</b> :'+ typename.mobile +'</div><br>';
		}
		// this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Mobile No</b> :'+ typename.mobile +'</div><br>';
		this.printStr += '</div>';
		this.printStr += '<div><span style="float:left;clear:left;font_weight:bold"><b>Client ID</b> : ' + typename.client_no + '</span><span style="float:right;font_weight:bold"><b>GST No </b> : ' + typename.tinno + '</span></div>';
		this.printStr += '<div><span style="float:right;font_weight:bold"><b>Bill No</b> : ' + branch_short_name + ' ' + typename.bill_no + '</span><span style="float:right;clear:left;"><b>Bill Type</b> : ' + typename.payment + '</span><span style="float:right;clear:right;font_weight:bold"><b>Bill Date</b> : ' + typename.disp_date + '</span></div>';
		this.printStr += '<table width="100%" border="0" cellspacing="0" cellpadding="5px" class="txt10"><thead class="thstk"><tr>';
		if(subTitle == 'TESTING BILL' || subTitle == 'SERVICE BILL' || subTitle == 'PRE-BOOKING BILL'){
			this.printStr += '<th class="thead" style="width:8em">QTY</th><th class="thead" style="width:20em">PARTICULARS</th><th class="thead" style="width:20em" colspan="2">AMOUNT</th>';
		}
		else if(subTitle == 'SALES BILL' || subTitle == 'HV BILL LIST' || subTitle == 'SOA BILL LIST' || subTitle == 'SPARE BILL'){
			this.printStr += '<th class="thead" style="width:5em">HSN Code</th><th class="thead" style="width:20em">PARTICULARS</th><th class="thead" style="width:8em">QTY</th><th class="thead" style="width:8em">PER PCS RATE</th><th class="thead" style="width:20em" colspan="2">AMOUNT</th>';
		}
		else{
			this.printStr += '<th class="thead" style="width:8em">QTY</th><th class="thead" style="width:20em">PARTICULARS</th><th class="thead" style="width:5em">HSN Code</th><th class="thead" style="width:20em" colspan="2">AMOUNT</th>';
		}
	
	}

	billFooter(printDet) {
		let description = printDet['rows'].description;
		if(printDet['subTitle'] == 'Service Ackowledment'){
			description = printDet['rows'].ack_description ? printDet['rows'].ack_description.split('<br>')[0] : '';
			// description = printDet['rows'].salesbill_description;
		} else if(printDet['subTitle'] == 'Service Bill'){
			description = printDet['rows'].salesbill_description ? printDet['rows'].salesbill_description.split('<br>')[0] : '';
		}
		if(description !=undefined){
			description = description.replace('Call by SG','');
		}
		this.printStr += '<div style="border-right: 1px solid;border-bottom: 1px solid;border-left: 1px solid;float: right;width: 100%;"><span style="float:left;font_weight:bold;font-size: 18px;"><b>Remarks :</b> ' + description + '</span><span style="float:right;font_weight:bold;padding: 10px 10px 0 0;">FOR SOUNDSGOOD HEARING CARE</span><span style="float:right;clear:right;font_weight:bold;padding: 40px 10px 10px 0;">AUTHORISED SIGNATURE</span></div>';
		this.printStr += '<table><tbody style="height:0 !important;"></tbody></table>';
		this.printStr += '<div style="text-align:center;margin-left:4em;font-size:12px">Madurai : 98430 62988 &bull; Madurai Anna Nagar : 84899 786 79 &bull; Madurai By-Pass : 84899 786 70 &bull; Coimbatore : 84899 786 77 <br> Tirunelveli : 9786 786 006 &bull; Theni : 84899 786 16 &bull; Tirupur : 84899 786 78 &bull; Nagarcoil : 84899 786 90 &bull; Tuticorin : 84899 78620 <br> Palayamkottai : 97867 86004 &bull; Coimbatore Peelamedu : 84899 78627</div>';
		// this.printStr += '<div style="text-align:center;clear:left;padding: 20px 0 10px 0">Madurai : 98430 62988 - Anna Nagar : 84899 786 79 - Coimbatore : 84899 78677 - Tirunelveli : 9786 786 006</div>';
		// this.printStr += '<div style="text-align:center;margin-left:4em;font-size:20px"><b>Toll Free Number : 1800 270 1996 <b></div>';
		// this.printStr += '<div style="text-align:center;margin-left:4em">Theni : 84899 786 16                - Tirupur : 84899 786 78    - Nagercoil : 84899 786 90 </div>';
		this.printStr += '</div>';
		let orinal = this.printStr;
		$('#printContent').html(orinal);
	}

	generateServiceDetail(pageDet) {
		let branch_short_name = '';
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) { branch_short_name = auth['branch_short_name']; }
		});
		const details = pageDet.rows;
		const discountAmt = parseFloat(details.discount) || 0;
		const serviceAdvanceAmt = parseFloat(details.service_advance_amt) || 0;
		const grandTotal = parseFloat(details.amount) || 0;
		const grossTotal = grandTotal + serviceAdvanceAmt + discountAmt;

		const C = '#1a3a8f';
		const G = '#16a34a';

		this.printStr = '';
		this.printStr += `<div style="font-family:Arial,sans-serif;font-size:13px;color:#000;max-width:780px;margin:0 auto;padding:8px 16px;display:flex;flex-direction:column;min-height:240mm;">`;

		// Header: full-width gradient, logo left 25%, tagline top-right inside gradient
		this.printStr += `<div style="background:linear-gradient(to top,white 20%,${C} 20%,${C} 55%,forestgreen 50%,forestgreen 85%,white 80%,white 100%);margin:0 -16px;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:flex;align-items:flex-start;justify-content:space-between;">`;
		this.printStr += `<img src="assets/images/logo-white-new.png" height="100" style="width:25%;display:block;margin-left:90px;">`;
		this.printStr += `<div style="padding:0px 25px 0 0;font-size:13px;font-style:italic;color:${G};font-weight:700;">Get Your Life Back</div>`;
		this.printStr += `</div>`;

		// Branch address
		this.printStr += `<div style="text-align:right;font-size:13px;color:#333;font-weight:bold;margin:4px 0 8px 0;line-height:1.5;max-width:55%;margin-left:auto;">${details.comp_address}</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Two-column: client info (left, padded down) | bill info (right) with HERO ELECTRONIC
		this.printStr += `<div style="display:flex;justify-content:space-between;gap:24px;margin:8px 0 10px 0;">`;
		this.printStr += `<div style="flex:1;font-size:13px;line-height:2;padding-top:30px;">`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">To Mr/Mrs</span>${details.client_name}</div>`;
		this.printStr += `<div style="display:flex;"><span style="font-weight:bold;min-width:100px;flex-shrink:0;">Address</span><span>${details.address}</span></div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">Mobile No</span>${(this.usertype != 'Super_Admin' && this.usertype != 'Admin') ? details.disp_mobile : details.mobile}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">Client ID</span>${details.client_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">HA Model</span>${details.mode_name || ''}</div>`;
		this.printStr += `</div>`;
		this.printStr += `<div style="min-width:260px;font-size:13px;line-height:1.9;">`;
		this.printStr += `<div style="font-size:22px;font-weight:900;color:#000;margin-bottom:6px;line-height:1.1;">HERO ELECTRONIC</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">GST Number</span>${details.tinno || ''}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Number</span>${(branch_short_name ? branch_short_name + ' ' : '') + details.bill_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">SRF No</span>${(branch_short_name ? branch_short_name + ' ' : '') + details.srf_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Date</span>${details.disp_date}</div>`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Bill title
		this.printStr += `<div style="text-align:center;font-size:15px;font-weight:bold;color:${C};letter-spacing:2px;margin:8px 0 12px 0;">SERVICE BILL</div>`;

		// Items table — one SRF row
		this.printStr += `<table class="sb-print-table" style="width:100%;border-collapse:collapse;font-size:13px;">`;
		this.printStr += `<thead><tr>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;width:8%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">QTY</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:40%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">Item Description</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:20%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">MODEL</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:20%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">SERIAL NO</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:right;font-weight:bold;width:12%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">AMOUNT</th>`;
		this.printStr += `</tr></thead><tbody>`;

		this.printStr += `<tr>`;
		this.printStr += `<td style="padding:8px 6px;text-align:center;width:8%;border-left:none;">1</td>`;
		this.printStr += `<td style="padding:8px 6px;width:40%;border-left:none;">SRF No: ${branch_short_name} ${details.srf_no}</td>`;
		this.printStr += `<td style="padding:8px 6px;width:20%;border-left:none;">${details.mode_name || ''}</td>`;
		this.printStr += `<td style="padding:8px 6px;width:20%;border-left:none;">${details.serial_nos || ''}</td>`;
		this.printStr += `<td style="padding:8px 6px;text-align:right;width:12%;border-left:none;">${grossTotal}</td>`;
		this.printStr += `</tr>`;
		this.printStr += `</tbody></table>`;

		// Totals (right-aligned)
		this.printStr += `<div style="display:flex;justify-content:flex-end;margin:6px 0 4px 0;">`;
		this.printStr += `<div style="flex-shrink:0;width:300px;">`;
		this.printStr += `<table class="sb-print-table" style="font-size:13px;width:100%;border-collapse:collapse;">`;
		this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;border-left:none;">Gross Total :</td><td style="padding:4px 0;text-align:right;min-width:90px;border-left:none;">${grossTotal}</td></tr>`;
		if (serviceAdvanceAmt > 0) {
			this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;border-left:none;">Advance Amount :</td><td style="padding:4px 0;text-align:right;border-left:none;">${serviceAdvanceAmt}</td></tr>`;
		}
		if (discountAmt > 0) {
			this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;border-left:none;">Discount Amount :</td><td style="padding:4px 0;text-align:right;border-left:none;">${discountAmt}</td></tr>`;
		}
		this.printStr += `<tr style="border-top:2px solid ${C};border-bottom:2px solid ${C};">`;
		this.printStr += `<td style="padding:6px 20px 6px 0;text-align:right;font-weight:bold;font-size:14px;border-left:none;">Total Amount :</td>`;
		this.printStr += `<td style="padding:6px 0;text-align:right;font-weight:bold;font-size:14px;border-left:none;">${grandTotal}</td>`;
		this.printStr += `</tr>`;
		this.printStr += `</table></div></div>`;

		// Remarks + Note + Signature
		const description = details.salesbill_description ? details.salesbill_description.split('<br>')[0] : (details.description || '');
		this.printStr += `<div style="display:flex;align-items:flex-start;margin:4px 0 10px 0;margin-top:auto;">`;
		this.printStr += `<div style="flex:1;font-size:12px;"><div style="font-weight:bold;font-size:13px;margin-bottom:4px;">Remarks :</div><div>${description}</div><div style="margin-top:8px;font-size:11px;"><b style="color:${C};">Note :</b> Service Undertaken / Goods Once Sold cannot be Return/Exchanged. Service is valid for only 3 months.</div></div>`;
		this.printStr += `<div style="min-width:35%;text-align:center;font-size:14px;color:${C};font-weight:600;font-style:italic;">Signature</div>`;
		this.printStr += `</div>`;

		// Footer contact row
		this.printStr += `<div style="display:flex;justify-content:space-between;font-size:14px;color:#111;font-weight:600;padding:8px 0;border-top:2px solid ${C};border-bottom:2px solid ${C};margin:8px 0 4px 0;">`;
		this.printStr += `<span>hello@soundsgood.in</span>`;
		this.printStr += `<span>www.soundsgood.in</span>`;
		this.printStr += `<span>Toll Free 1800 270 196</span>`;
		this.printStr += `</div>`;

		// Branch numbers — dark navy background with white text
		this.printStr += `<div style="background:${C};font-size:10px;text-align:center;color:#fff;line-height:1.9;padding:6px 8px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">`;
		this.printStr += `<b>Madurai:</b> 98430 62988 &bull; <b>Madurai Anna Nagar:</b> 84899 78679 &bull; <b>Madurai By-Pass:</b> 84899 78670 &bull; <b>Coimbatore:</b> 84899 78677, <b>Tirunelveli:</b> 97867 86006 &bull; <b>Theni:</b> 84899 78616 &bull; <b>Tirupur:</b> 84899 78679 &bull; <b>Nagarcoil:</b> 84899 78690 &bull; <b>Tuticorin:</b> 84899 78620, <b>Palayamkottai:</b> 97867 86004 &bull; <b>Coimbatore Peelamedu:</b> 84899 78627, <b>Ramanathapuram:</b> 84899 78689`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;
		$('#printContent').html(this.printStr);
	}

	generateTestDetail(pageDet) {
		const rowDet = pageDet.rows;
		let branch_short_name = '';
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) { branch_short_name = auth['branch_short_name']; }
		});

		const C = '#1a3a8f';
		const G = '#16a34a';

		this.printStr = '';
		this.printStr += `<div style="font-family:Arial,sans-serif;font-size:13px;color:#000;max-width:780px;margin:0 auto;padding:8px 16px;display:flex;flex-direction:column;min-height:240mm;">`;

		// Header: full-width gradient, logo on left 25%, tagline top-right
		this.printStr += `<div style="background:linear-gradient(to top,white 20%,${C} 20%,${C} 55%,forestgreen 50%,forestgreen 85%,white 80%,white 100%);margin:0 -16px;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:flex;align-items:flex-start;justify-content:space-between;">`;
		this.printStr += `<img src="assets/images/logo-white-new.png" height="100" style="width:25%;display:block;margin-left:90px;">`;
		this.printStr += `<div style="padding:0px 25px 0 0;font-size:13px;font-style:italic;color:${G};font-weight:700;">Get Your Life Back</div>`;
		this.printStr += `</div>`;
		this.printStr += `<div style="text-align:right;font-size:13px;color:#333;font-weight:bold;margin:4px 0 8px 0;line-height:1.5;max-width:55%;margin-left:auto;">${rowDet.comp_address}</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:10px 0;"></div>`;

		// Two-column: client info (left) | bill info (right)
		this.printStr += `<div style="display:flex;justify-content:space-between;gap:24px;margin:8px 0 10px 0;">`;
		this.printStr += `<div style="flex:1;font-size:13px;line-height:2;padding-top:30px;">`;
		this.printStr += `<div><span style="font-weight:bold;min-width:90px;display:inline-block;">Name</span>${rowDet.client_name}</div>`;
		this.printStr += `<div style="display:flex;"><span style="font-weight:bold;min-width:90px;flex-shrink:0;">Address</span><span>${rowDet.address}</span></div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:90px;display:inline-block;">Client Id</span>${rowDet.client_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:90px;display:inline-block;">Phone</span>${rowDet.mobile}</div>`;
		this.printStr += `</div>`;
		this.printStr += `<div style="min-width:260px;font-size:13px;line-height:1.9;">`;
		this.printStr += `<div style="font-size:22px;font-weight:900;color:#000;margin-bottom:6px;line-height:1.1;">HERO ELECTRONIC</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">GST Number</span>${rowDet.tinno || ''}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Number</span>${(branch_short_name ? branch_short_name + ' ' : '') + rowDet.bill_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Type</span>${rowDet.payment}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Date</span>${rowDet.disp_date}</div>`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Bill title
		this.printStr += `<div style="text-align:center;font-size:15px;font-weight:bold;color:${C};letter-spacing:2px;margin:8px 0 12px 0;">TESTING BILL</div>`;

		// Items table
		this.printStr += `<table class="sb-print-table" style="width:100%;border-collapse:collapse;font-size:13px;">`;
		this.printStr += `<thead><tr>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;width:10%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">QTY</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:75%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">PARTICULARS</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:right;font-weight:bold;width:15%;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">AMOUNT</th>`;
		this.printStr += `</tr></thead><tbody>`;

		for (let i of rowDet.det) {
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;width:10%;border-left:none;">1</td>`;
			this.printStr += `<td style="padding:8px 6px;width:75%;border-left:none;">${i.testingtype_name}</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:right;width:15%;border-left:none;">${i.fees}</td>`;
			this.printStr += `</tr>`;
		}

		this.printStr += `</tbody></table>`;

		// Totals (right-aligned block)
		this.printStr += `<div style="display:flex;justify-content:flex-end;margin:8px 0 4px 0;">`;
		this.printStr += `<table class="sb-print-table" style="font-size:13px;border-collapse:collapse;min-width:280px;">`;
		this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;border-left:none;">Subtotal:</td><td style="padding:4px 0;text-align:right;min-width:80px;border-left:none;">${rowDet.gross_total}</td></tr>`;
		if (rowDet.discount_amount && parseFloat(rowDet.discount_amount) > 0) {
			this.printStr += `<tr><td style="padding:4px 20px 4px 0;text-align:right;border-left:none;">Discount:</td><td style="padding:4px 0;text-align:right;border-left:none;">${rowDet.discount_amount}</td></tr>`;
		}
		this.printStr += `<tr style="border-top:2px solid ${C};border-bottom:2px solid ${C};">`;
		this.printStr += `<td style="padding:6px 20px 6px 0;text-align:right;font-weight:bold;font-size:14px;border-left:none;">Total Amount:</td>`;
		this.printStr += `<td style="padding:6px 0;text-align:right;font-weight:bold;font-size:14px;border-left:none;">${rowDet.amount}</td>`;
		this.printStr += `</tr>`;
		this.printStr += `</table></div>`;

		// Footer contact row
		this.printStr += `<div style="margin-top:auto;page-break-inside:avoid;break-inside:avoid;">`;
			this.printStr += `<div style="display:flex;justify-content:space-between;font-size:14px;color:#111;font-weight:600;padding:8px 0;border-top:2px solid ${C};border-bottom:2px solid ${C};margin:8px 0 4px 0;">`;
		this.printStr += `<span>hello@soundsgood.in</span>`;
		this.printStr += `<span>www.soundsgood.in</span>`;
		this.printStr += `<span>Toll Free 1800 270 196</span>`;
		this.printStr += `</div>`;

		// Branch numbers — dark navy background with white text
		this.printStr += `<div style="background:${C};font-size:10px;text-align:center;color:#fff;line-height:1.9;padding:6px 8px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">`;
		this.printStr += `<b>Madurai:</b> 98430 62988 &bull; <b>Madurai Anna Nagar:</b> 84899 78679 &bull; <b>Madurai By-Pass:</b> 84899 78670 &bull; <b>Coimbatore:</b> 84899 78677, <b>Tirunelveli:</b> 97867 86006 &bull; <b>Theni:</b> 84899 78616 &bull; <b>Tirupur:</b> 84899 78679 &bull; <b>Nagarcoil:</b> 84899 78690 &bull; <b>Tuticorin:</b> 84899 78620, <b>Palayamkottai:</b> 97867 86004 &bull; <b>Coimbatore Peelamedu:</b> 84899 78627, <b>Ramanathapuram:</b> 84899 78689`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;
		$('#printContent').html(this.printStr);
	}

	genarateSpareBill(pageDet) {
		let typename = pageDet.rows;
		this.billHeader(pageDet);
		let gst = {};
		let arr = [];
		for (let i of typename.det) {
			if (i.free_item != 'Yes') {
				let gper = i.gstper + '';
				if (!gst[gper]) {
					gst[gper] = {
						gstper: gper,
						gstamt: 0//parseFloat(i.gstamt)
					}
				}
				gst[gper].gstamt += parseFloat(i.gstamt);
			}
		}
		for (let i of Object.keys(gst)) {
			arr.push(gst[i]);
		}
		var showgst = true;
		for (let i of arr) {
			if (i.gstper == 0) {
				showgst = false;
			} else {
				showgst = true;
			}
		}
		let grstotal =0 ,totcgst =0,totsgst = 0;
		let grossTot,cgstTot,sgstTot;
		for (let i of typename.det) {
			if (i.free_item != 'Yes') {
				let gper = 18;
				let cgst,sgst,pergst = 0;
				i.amt ,i.cgst, i.sgst = 0;
				pergst = i.machine_price * (gper / 100);
				cgst =  pergst / 2;
				sgst = pergst /2 ;
				i.amt = i.machine_price - pergst;
				i.cgst = cgst;
				i.sgst = sgst;
				grstotal += i.amt;
				totcgst += cgst;
				totsgst += sgst;
				
			}
		}
		console.log("gross total", grstotal);

		grossTot =parseFloat(grstotal.toString()).toFixed(2);
		cgstTot = parseFloat(totcgst.toString()).toFixed(2);
		sgstTot = parseFloat(totsgst.toString()).toFixed(2);

		const taxableValue = Number((typename.amount / (1 + 0.18)).toFixed(2));
		const cgstAmt = taxableValue * 0.09;
		const sgstAmt = taxableValue * 0.09;
		const totalAmt = Number((Number(taxableValue) + Number(cgstAmt) + Number(sgstAmt)).toFixed(2));

		for (let i of typename.det) {
			if(i.hsn_name == null)
			{
				i.hsn_name ='';
			}
			// if(i.excha_repl_type == 'Sales Return')
			// {
			// 	this.printStr += '<tr><td style="text-align:center" class="tblbdr">' + i.machine_qty + '</td><td style="text-align:left" class="tblbdr">' + i.machine_name + ' - Serial_No (' + i.serial_no + ') ('+ i.transaction_type+') ('+ i.machine_price +')</td><td class="txtalnr tblbdr" style="padding-right:15px">' + i.hsn_name + '</td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px"></td></tr>';
			// }
			// else{
				if(i.free_item == 'No')
				{
					this.printStr += '<tr><td class="txtalnr tblbdr" style="padding-right:15px">' + i.hsn_name + '</td><td style="text-align:left" class="tblbdr">' + i.machine_name + ' - Serial_No (' + i.serial_no + ')</td><td style="text-align:center" class="tblbdr">' + i.machine_qty + '</td><td class="txtalnr tblbdr" style="padding-right:15px">' + i.rate + '</td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px">' + i.machine_price + '</td></tr>';
				}
				else if(i.free_item == 'Yes'){
					this.printStr += '<tr><td class="txtalnr tblbdr" style="padding-right:15px">' + i.hsn_name + '</td><td style="text-align:left" class="tblbdr">' + i.machine_name + ' - Serial_No (' + i.serial_no + ')</td><td style="text-align:center" class="tblbdr">' + i.machine_qty + '</td><td class="txtalnr tblbdr" style="padding-right:15px">' + i.rate + '</td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px"></td></tr>';
				}
				
			// }
			
		}
		// EXCHANGE - REPLACEMENT DETAILS
		let exRepPrintDet = '<td></td><td></td><td></td>';
		if(typename.transaction_type == 'Exchange' || typename.transaction_type == 'Replacement') {
			exRepPrintDet ='<td></td><td>';
		for (let i of typename.rep_exc_det) {
			if(i.hsn_name == null)
			{
				i.hsn_name ='';
			}
			// if(i.excha_repl_type == 'Sales Return')
			// {
			// 	this.printStr += '<tr><td style="text-align:center" class="tblbdr">' + i.machine_qty + '</td><td style="text-align:left" class="tblbdr">' + i.machine_name + ' - Serial_No (' + i.serial_no + ') ('+ i.transaction_type+') ('+ i.machine_price +')</td><td class="txtalnr tblbdr" style="padding-right:15px">' + i.hsn_name + '</td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px"></td></tr>';
			// }
			// else{
				exRepPrintDet += '<b>Bill No</b> (' + i.mrauto_no + ') - <b>'+i.machine_name + '</b> - Serial_No (' + i.serial_no + ') - HSN Code (' + i.hsn_name +') - Price(' + i.machine_price + ')<br>'
			// }
		}
		exRepPrintDet +='</td>';
		}
		
		if(typename.transaction_type == 'Exchange' || typename.transaction_type == 'Replacement') {
			exRepPrintDet += '<td><b>' + typename.transaction_type.toUpperCase() + ' AMOUNT : ' + typename.return_bill_amt + '</b></td>';
		}
		this.printStr += '<tr>' + exRepPrintDet + '<td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Gross Total     :<span class="alnn">' + typename.gross_total + '</span></td></tr>';
		// if (typename.less_amount > 0) {
		// 	this.printStr += '<tr><td></td><td></td><td></td><td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Less Amount     :<span class="alnn">' + typename.less_amount + '</span></td></tr>';
		// }
		// this.printStr += '<tr><td></td><td></td><td></td><td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">CGST     :<span class="alnn">' + cgstTot + '</span></td></tr>';
		// this.printStr += '<tr><td></td><td></td><td></td><td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">SGST     :<span class="alnn">' + sgstTot + '</span></td></tr>';
		this.printStr += '<tr rowspan="6"><td class="totbbrd" rowspan="6"></td><td style="padding-top:0;padding-bottom:0;border-bottom:1px solid ;font-size:12px" rowspan="6"><b>Note :</b> Service Undertaken/Goods Once Sold cannot be Return/Exchanged</td><td class="totbbrd" rowspan="6"></td><td class="totbbrd" rowspan="6"></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Discount Amount     :<span class="alnn">' + typename.discount_amount + '</span></td></tr>';
		if(typename.advances)
		{
			this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;">Advance Amount     :<span class="alnn">' + typename.advances + '</span></td></tr>';
		}
		this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;">Total Amount     :<span class="alnn" style="border-top:1px dashed;border-bottom: 1px dashed;">' + typename.amount + '</span></td></tr>';

		this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;">Taxable Value     :<span class="alnn">' + taxableValue + '</span></td></tr>';

		this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;">CGST     :<span class="alnn">' + cgstAmt.toFixed(2) + '</span></td></tr>';

		this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;">SGST     :<span class="alnn">' + sgstAmt.toFixed(2) + '</span></td></tr>';

		this.printStr += '<tr><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;border-bottom: 1px solid black;">Total     :<span class="alnn" style="border-top:1px dashed;border-bottom: 1px dashed;">' + Math.round(totalAmt) + '</span></td></tr>';

		// if (showgst != false && typename.amount != 0) {
		// 	this.printStr += '<tr><td style="border-right: 1px solid;" colspan="2"><span style="border-bottom:1px solid">GST</span></td></tr>';
		// }
		// for (let i of arr) {
		// 	if (i.gstper != 0) {
		// 		let gstc = i.gstper / 2;
		// 		this.printStr += '<tr><td style="border-right: 1px solid; border-bottom: 1px solid black;" colspan="2">' + i.gstper + '% : (CGST : ' + gstc + ' , SGST : ' + gstc + ') = ' + i.gstamt + '</td></tr>';
		// 	}
		// }
		this.printStr += '</thead></table>';
		this.billFooter(pageDet);
	}

	genarateSalesBill(pageDet) {
		let typename = pageDet.rows;
		let branch_short_name = '';
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) { branch_short_name = auth['branch_short_name']; }
		});

		const typeLabel = {
			'HV': 'HV BILL', 'SOA': 'SOA BILL', 'Advance': 'PRE-BOOKING BILL',
			'Pre-Booking Bill': 'PRE-BOOKING BILL', 'Spare Bill': 'SPARE BILL',
			'Sales Bill': 'SALES BILL', 'HV Bill List': 'HV BILL', 'SOA Bill List': 'SOA BILL'
		};
		let subTitle = '';
		if (typename.transaction_type == 'Exchange' || typename.transaction_type == 'Replacement' || typename.transaction_type == 'Trial') {
			subTitle = typename.transaction_type.toUpperCase() + ' - ';
		}
		subTitle += (typeLabel[pageDet['type']] || pageDet['subTitle'].toUpperCase());

		const isAdvance = pageDet['type'] == 'Advance' || pageDet['type'] == 'Pre-Booking Bill';

		let grossTotal = typename.gross_total;
		if (Number(typename.less_amount)) {
			grossTotal = Number(typename.gross_total) - Number(typename.less_amount);
		}

		const C = '#1a3a8f';
		const G = '#16a34a';
		const fmt = (v) => v ? '₹' + Number(v).toLocaleString('en-IN') : '₹0';

		this.printStr = '';
		this.printStr += `<div style="font-family:Arial,sans-serif;font-size:13px;color:#000;max-width:780px;margin:0 auto;padding:8px 16px;display:flex;flex-direction:column;min-height:240mm;">`;

		// Header: full-width gradient, logo on left 25%, tagline top-right
		this.printStr += `<div style="background:linear-gradient(to top,white 20%,${C} 20%,${C} 55%,forestgreen 50%,forestgreen 85%,white 80%,white 100%);margin:0 -16px;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:flex;align-items:flex-start;justify-content:space-between;">`;
		this.printStr += `<img src="assets/images/logo-white-new.png" height="100" style="width:25%;display:block;margin-left:90px;">`;
		this.printStr += `<div style="padding:0px 25px 0 0;font-size:13px;font-style:italic;color:${G};font-weight:700;">Get Your Life Back</div>`;
		this.printStr += `</div>`;

		// Branch address below header
		this.printStr += `<div style="text-align:right;font-size:13px;color:#333;font-weight:bold;margin:4px 0 8px 0;line-height:1.5;max-width:55%;margin-left:auto;">${typename.comp_address}</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Two-column: client info (left) | company + bill info (right)
		this.printStr += `<div style="display:flex;justify-content:space-between;gap:24px;margin:8px 0 10px 0;">`;

		this.printStr += `<div style="flex:1;font-size:13px;line-height:2;padding-top:30px;">`;
		this.printStr += `<div><span style="font-weight:bold;min-width:80px;display:inline-block;">Name</span>${typename.client_name}</div>`;
		this.printStr += `<div style="display:flex;"><span style="font-weight:bold;min-width:80px;flex-shrink:0;">Address</span><span>${typename.address}</span></div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:80px;display:inline-block;">Client Id</span>${typename.client_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:80px;display:inline-block;">Phone</span>${typename.mobile}</div>`;
		this.printStr += `</div>`;

		this.printStr += `<div style="min-width:250px;font-size:13px;line-height:1.9;">`;
		this.printStr += `<div style="font-size:22px;font-weight:900;color:#000;margin-bottom:6px;line-height:1.1;">HERO ELECTRONIC</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">GST Number</span>${typename.tinno || ''}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Number</span>${(branch_short_name ? branch_short_name + ' ' : '') + typename.bill_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Type</span>${typename.payment}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Bill Date</span>${typename.disp_date}</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Bill title
		this.printStr += `<div style="text-align:center;font-size:15px;font-weight:bold;color:${C};letter-spacing:2px;margin:8px 0 12px 0;">${subTitle}</div>`;

		// Items table — top border via div (more reliable than outer <th> border-top with border-collapse:collapse)
		this.printStr += `<div style="border-top:2px solid ${C};margin:0;"></div>`;
		this.printStr += `<table class="sb-print-table" style="width:100%;border-collapse:collapse;font-size:13px;">`;
		this.printStr += `<thead><tr>`;
		this.printStr += `<th style="padding:8px 6px 8px 0;text-align:left;font-weight:bold;border-bottom:2px solid ${C};border-left:none;">HSN Code</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;border-bottom:2px solid ${C};">Item Description</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;border-bottom:2px solid ${C};">Serial No</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;border-bottom:2px solid ${C};">Qty</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:right;font-weight:bold;border-bottom:2px solid ${C};">Rate</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;border-bottom:2px solid ${C};">Free</th>`;
		this.printStr += `<th style="padding:8px 0 8px 6px;text-align:right;font-weight:bold;border-bottom:2px solid ${C};">Total</th>`;
		this.printStr += `</tr></thead><tbody>`;

		for (let i of typename.det) {
			if (i.hsn_name == null) { i.hsn_name = ''; }
			const amtCell = i.free_item == 'Yes' ? '₹0' : fmt(i.machine_price);
			const freeCell = i.free_item == 'Yes' ? 'Yes' : 'No';
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:8px 6px 8px 0;border-left:none;">${i.hsn_name}</td>`;
			this.printStr += `<td style="padding:8px 6px;">${i.machine_name}</td>`;
			this.printStr += `<td style="padding:8px 6px;">${i.serial_no || ''}</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;">${i.machine_qty}</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:right;">${fmt(i.rate)}</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;">${freeCell}</td>`;
			this.printStr += `<td style="padding:8px 0 8px 6px;text-align:right;">${amtCell}</td>`;
			this.printStr += `</tr>`;
		}

		if (typename.transaction_type == 'Exchange' || typename.transaction_type == 'Replacement') {
			let excDet = '';
			for (let i of typename.rep_exc_det) {
				if (i.hsn_name == null) { i.hsn_name = ''; }
				excDet += `<b>Bill No</b> (${i.mrauto_no}) - <b>${i.machine_name}</b> - Serial_No (${i.serial_no}) - HSN Code (${i.hsn_name}) - Price (${i.machine_price})<br>`;
			}
			this.printStr += `<tr><td colspan="6" style="padding:8px 0;font-size:10px;">`;
			this.printStr += `<b style="color:${C};">${typename.transaction_type.toUpperCase()} DETAILS :</b> ${excDet}`;
			this.printStr += `<b style="color:${C};">${typename.transaction_type.toUpperCase()} AMOUNT : ${typename.return_bill_amt}</b>`;
			this.printStr += `</td></tr>`;
		}

		this.printStr += `</tbody></table>`;

		// Totals — right-aligned; sb-print-table removes the print.css left-border on first-child
		this.printStr += `<div style="display:flex;justify-content:flex-end;margin:8px 0 4px 0;">`;
		this.printStr += `<table class="sb-print-table" style="font-size:13px;min-width:260px;border-collapse:collapse;">`;
		this.printStr += `<tr><td style="padding:5px 20px 5px 0;text-align:right;border-left:none;">Subtotal:</td><td style="padding:5px 0;text-align:right;min-width:90px;">${fmt(grossTotal)}</td></tr>`;
		if (typename.advances) {
			this.printStr += `<tr><td style="padding:5px 20px 5px 0;text-align:right;border-left:none;">Advance:</td><td style="padding:5px 0;text-align:right;">${fmt(typename.advances)}</td></tr>`;
		}
		if (typename.discount_amount) {
			this.printStr += `<tr><td style="padding:5px 20px 5px 0;text-align:right;border-left:none;">Discount:</td><td style="padding:5px 0;text-align:right;">${fmt(typename.discount_amount)}</td></tr>`;
		}
		if (isAdvance) {
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:7px 20px 7px 0;text-align:right;font-weight:bold;font-size:14px;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">Balance:</td>`;
			this.printStr += `<td style="padding:7px 0;text-align:right;font-weight:bold;font-size:14px;border-top:2px solid ${C};border-bottom:2px solid ${C};">${fmt(typename.amount)}</td>`;
			this.printStr += `</tr>`;
		} else {
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:7px 20px 7px 0;text-align:right;font-weight:bold;font-size:14px;border-top:2px solid ${C};border-bottom:2px solid ${C};border-left:none;">Total Amount:</td>`;
			this.printStr += `<td style="padding:7px 0;text-align:right;font-weight:bold;font-size:14px;border-top:2px solid ${C};border-bottom:2px solid ${C};">${fmt(typename.amount)}</td>`;
			this.printStr += `</tr>`;
		}
		this.printStr += `</table></div>`;

		// Terms & Conditions / Signature
		const description = typename.description || '';
		this.printStr += `<div style="display:flex;gap:24px;margin:4px 0 10px 0;font-size:13px;margin-top:auto;">`;
		this.printStr += `<div style="flex:1;"><div style="font-weight:bold;margin-bottom:4px;">Terms and Conditions</div>`;
		this.printStr += `<div style="color:#555;font-size:12px;">${description || 'Service undertaken / Goods once sold cannot be taken back or exchange'}</div></div>`;
		this.printStr += `<div style="min-width:160px;"><span style="color:${C};font-weight:600;font-size:14px;">Signature</span></div>`;
		this.printStr += `</div>`;

		// Footer — email | website | toll free (large dark, bordered top+bottom)
		this.printStr += `<div style="display:flex;justify-content:space-between;font-size:15px;color:#111;font-weight:600;padding:8px 0;border-top:2px solid ${C};border-bottom:2px solid ${C};margin:8px 0 4px 0;">`;
		this.printStr += `<span>hello@soundsgood.in</span>`;
		this.printStr += `<span>www.soundsgood.in</span>`;
		this.printStr += `<span>Toll Free 1800 270 196</span>`;
		this.printStr += `</div>`;

		// Branch numbers — dark navy background with white text
		this.printStr += `<div style="background:${C};font-size:10px;text-align:center;color:#fff;line-height:1.9;padding:6px 8px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">`;
		this.printStr += `<b>Madurai:</b> 98430 62988 &bull; <b>Madurai Anna Nagar:</b> 84899 78679 &bull; <b>Madurai By-Pass:</b> 84899 78670 &bull; <b>Coimbatore:</b> 84899 78677, <b>Tirunelveli:</b> 97867 86006 &bull; <b>Theni:</b> 84899 78616 &bull; <b>Tirupur:</b> 84899 78679 &bull; <b>Nagarcoil:</b> 84899 78690 &bull; <b>Tuticorin:</b> 84899 78620, <b>Palayamkottai:</b> 97867 86004 &bull; <b>Coimbatore Peelamedu:</b> 84899 78627, <b>Ramanathapuram:</b> 84899 78689`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;

		$('#printContent').html(this.printStr);
	}

	genarateAdvanceBill(pageDet) {
		let typename = pageDet.rows;
		this.billHeader(pageDet);
		for (let i of typename.det) {
			this.printStr += '<tr><td style="text-align:center" class="tblbdr">' + i.machine_qty + '</td><td style="text-align:left" class="tblbdr">' + i.machine_name + '</td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px">' + i.machine_price + '</td></tr>';
		}
		this.printStr += '<tr><td></td><td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Gross Total     :<span class="alnn">' + typename.gross_total + '</span></td></tr>';
		if (typename.less_amount > 0) {
			this.printStr += '<tr><td></td><td></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Less Amount     :<span class="alnn">' + typename.less_amount + '</span></td></tr>';
		}
		if (typename.discount_amount > 0) {
			this.printStr += '<tr><td></td><td style="padding-top:0;padding-bottom:0"></td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Discount Amount     :<span class="alnn">' + typename.discount_amount + '</span></td></tr>';
		}
		this.printStr += '<tr><td></td><td style="padding-top:0;padding-bottom:0;border-bottom:1px solid;font-size:12px;" rowspan="2"><b>Note :</b> Service Undertaken/Goods Once Sold cannot be Return/Exchanged</td><td class="totbord" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Advance Amount     :<span class="alnn">' + typename.advances + '</span></td></tr>';
		this.printStr += '<tr><td class="totbbrd"></td><td class="totbord totbbrd" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Balance     :<span class="alnn" style="border-top:1px dashed">' + typename.amount + '</span></td></tr>';
		this.printStr += '</thead></table>';
		this.billFooter(pageDet);
	}

	genarateCashreceipt(data) {
		let title = data['title'],
			subtitle = data['subTitle']
		let printData = data.rows;
		let amount = this.numberToWord(printData.amount);
		this.printStr += '<div class="txt10">';
		this.printStr += '<div style="float:right;font_weight:bold"><b>Email</b> : hello@soundsgood.in</div>';
		this.printStr += '<div><span style="font_weight:bold;font-size: 10px;text-align: center;float:left;left: 25%;position: absolute;top: 22px;">Unit of <span style="color: #D22B2B;font-size:20px;"><b>hero</b></span> <span style="color: #87CEEB;font-size:18px;"><i> electronic</i></span></span><span  style="float:right;clear:right;font_weight:bold"> <b>Web site</b> : www.soundsgood.in </span></div>';
		this.printStr += '<br>';
		this.printStr += '<div style="background: linear-gradient(to top,white 20%,#2b2c87 20%, #2b2c87 55%,forestgreen 50%, forestgreen 85%,white 80%, white 100%);"><img src = "assets/images/logo-white-new.png" height="100" width="200" class="img"></div>';
		this.printStr += '<div style="font-weight:normal;font-size:10px;text-align: center;left: 25%;position: absolute;margin-top: -1%">' +  printData.comp_address + ', Ph ' + printData.phoneno + ', Mobile ' + printData.comp_mobile + '</div>'
		this.printStr += '<div style="text-align: center;margin-top: 1%;"><span class="com_title">' + subtitle + '</span></div>';
		this.printStr += '<div style="padding-top:10px"><span><b>Receipt No :</b> ' + printData.auto_no + '</span><span style="float:right"><b>GST No :</b> ' + printData.tinno + '</span></div>';
		this.printStr += '<div style="padding-bottom:10px"><span><b>Bill Type :</b> ' + printData.type + '</span><span style="float:right"><b>Date :</b> ' + printData.disp_date + '</span></div>';
		this.printStr += '<div class="rcptborder">';
		this.printStr += '<div style="clear:left;float:left;padding-bottom:12px;padding-top:5px"><b> Received From Mr/Mrs </b><u class="recpt">' + printData.client_name + '</u> Of Rupees<u class="recpt"> ' + amount + '</u> Only For <u class="recpt">' + printData.description + '</u></div><br>';
		this.printStr += '<div><span class="rcpt" style="border-radius: 6px 0px 0px 6px"><b>RS</b></span><span style="float: left;padding: 9px;border: 1px solid;border-radius: 0px 6px 6px 0px">' + printData.amount + '</span></div>';
		this.printStr += '</div>';
		this.printStr += '<div style="text-align:center;margin-left:4em;font-size:20px"><b>Toll Free Number  : 1800 270 1996 <b></div>';
		// this.printStr += '<div style="text-align:center;clear:left;padding-top:5px">Madurai : 98430 62988 - Anna Nagar : 84899 786 79 - Coimbatore : 84899 78677 - Tirunelveli : 9786 786 006</div>';
		// this.printStr += '<div style="text-align:center;margin-left:4em">Theni : 84899 786 16                - Tirupur : 84899 786 78    - Nagercoil : 84899 786 90 </div>';
		this.printStr += '</div>';
		let orinal = this.printStr;
		$('#printContent').html(orinal);
	}
	numberToWord(amount) {
		var words = new Array();
		words[0] = '';
		words[1] = 'One';
		words[2] = 'Two';
		words[3] = 'Three';
		words[4] = 'Four';
		words[5] = 'Five';
		words[6] = 'Six';
		words[7] = 'Seven';
		words[8] = 'Eight';
		words[9] = 'Nine';
		words[10] = 'Ten';
		words[11] = 'Eleven';
		words[12] = 'Twelve';
		words[13] = 'Thirteen';
		words[14] = 'Fourteen';
		words[15] = 'Fifteen';
		words[16] = 'Sixteen';
		words[17] = 'Seventeen';
		words[18] = 'Eighteen';
		words[19] = 'Nineteen';
		words[20] = 'Twenty';
		words[30] = 'Thirty';
		words[40] = 'Forty';
		words[50] = 'Fifty';
		words[60] = 'Sixty';
		words[70] = 'Seventy';
		words[80] = 'Eighty';
		words[90] = 'Ninety';
		amount = amount.toString();
		var atemp = amount.split(".");
		var number = atemp[0].split(",").join("");
		var n_length = number.length;
		var words_string = "";
		if (n_length <= 9) {
			var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
			var received_n_array = new Array();
			for (var i = 0; i < n_length; i++) {
				received_n_array[i] = number.substr(i, 1);
			}
			for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
				n_array[i] = received_n_array[j];
			}
			for (var i = 0, j = 1; i < 9; i++, j++) {
				if (i == 0 || i == 2 || i == 4 || i == 7) {
					if (n_array[i] == 1) {
						n_array[j] = 10 + (n_array[j]);
						n_array[i] = 0;
					}
				}
			}
			let value = number;
			for (var i = 0; i < 9; i++) {
				if (i == 0 || i == 2 || i == 4 || i == 7) {
					value = n_array[i] * 10;
				} else {
					value = n_array[i];
				}
				if (value != 0) {
					words_string += words[value] + " ";
				}
				if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
					words_string += "Crores ";
				}
				if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
					words_string += "Lakhs ";
				}
				if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
					words_string += "Thousand ";
				}
				if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
					words_string += "Hundred and ";
				} else if (i == 6 && value != 0) {
					words_string += "Hundred ";
				}
			}
			words_string = words_string.split("  ").join(" ");
		}
		return words_string;
	}
	genarteSOADetail(data) {
		let print = data.rows;

		let soaprintStr = '';
		soaprintStr += `<div>
		<div class="soatle">${data.subTitle}</div>
			<div style="float:left">Doctor Name</div><div class="soact">: ${print[0].reference}</div><br>
			<div style="float:left">Place</div><div class="soact">: ${print[0].city}</div><br>
			<div style="float:left">Appoinment Date</div><div class="soact">: ${print[0].curr_date}</div><br>
			<div style="float:left">Appoinment Time</div><div class="soact">: </div><br>
			<div style="float:left">Compinations</div><div class="soact">:  ${print[0].combination}</div><br>
			<div style="float:left">Travelling Exp</div><div class="soact">: </div><br>
			<div style="float:left"><b>Dr's Commision paid</div><div class="soact">: Yes / No</b></div><br>
			<div class="soatle">Customer Details</div>
			<table class="txt10 brd" width="100%" border="0">
			<tr class="brd">
				<th class="brd">S.no</th><th class="brd">Customer Name</th><th class="brd">Phone Number</th><th class="brd">Address</th><th class="brd">Age</th><th class="brd">Testing</th><th class="brd">Machine Details</th><th class="brd">Amount</th><th class="brd">Bill No</th><th class="brd">Free Item</th>
			</tr>
			`
		let no = 1;
		for (let i = 0; i < 10; i++) {
			soaprintStr += `<tr><td class="brd" style="padding:40px"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td><td class="brd"></td></tr>`;
			no++;
		}
		`
			</div>`
		$('#printContent').html(soaprintStr);
	}
	genarateHVSOAOUTBill(pageDet) {
		let title = pageDet['title'],
			subTitle = pageDet['subTitle'].toUpperCase();
		let align = 'center';
		let cls = 'hdr1';
		let type: any = pageDet;
		let typename = type.rows;
		cls += align == 'center' ? ' txtaligncenter' : '';
		this.printStr += '<div class="txt10">';
		this.printStr += '<div style="float:right;font_weight:bold"><b>Email</b> : hello@soundsgood.in</div>';
		this.printStr += '<div><span style="font_weight:bold;font-size: 10px;text-align: center;float:left;left: 25%;position: absolute;top: 22px;">Unit of <span style="color: #D22B2B;font-size:20px;"><b>hero</b></span> <span style="color: #87CEEB;font-size:18px;"><i> electronic</i></span></span><span  style="float:right;clear:right;font_weight:bold"> <b>Web site</b> : www.soundsgood.in </span></div>';
		this.printStr += '<br>';
		this.printStr += '<div style="background: linear-gradient(to top,white 20%,#2b2c87 20%, #2b2c87 55%,forestgreen 50%, forestgreen 85%,white 80%, white 100%);"><img src = "assets/images/logo-white-new.png" height="100" width="200" class="img"></div>';
		this.printStr += '<div style="font-weight:normal;font-size:10px;text-align: center;left: 25%;position: absolute;margin-top: -1%">' + typename.comp_address + ', Ph ' + typename.phoneno + ', Mobile ' + typename.comp_mobile + '</div>'
		this.printStr += '<div style="text-align: center;margin-top: 1%;"><span class="com_title">' + subTitle + '</span></div>';
		if(subTitle != 'TRANSFER CHALLAN OUT' && subTitle != 'TRANSFER CHALLAN IN'){
			this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Employee Name</b> :' + typename.emp_name + '</div><br>';
		}
		else if(subTitle == 'TRANSFER CHALLAN OUT' || subTitle == 'TRANSFER CHALLAN IN'){
			if(typename.out_type == 'Branch'){
				this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Branch Name</b> :' + typename.branch_name + '</div><br>';
			}
			else if(typename.out_type == 'HV Team'){
				this.printStr += '<div style="clear:left;float:left;padding-bottom:5px;padding-top:5px"><b>Employee Name</b> :' + typename.hv_username + '</div><br>';
			}
			
		}
		//let todayDt = this.datePipe.transform(new Date(), 'dd/MM/yyyy hh:mm a');
		this.printStr += '</div>';
		this.printStr += '<div><span style="float:left;clear:left;font_weight:bold"><b>Challan No</b> : ' + typename.challan_no + '</span><span style="float:right;font_weight:bold"><b>Challan Date</b> : ' + typename.disp_date + '</span></div>';
		if(subTitle == 'TRANSFER CHALLAN IN'){
			this.printStr += '<div><span style="float:left;clear:left;font_weight:bold"><b>TC OUT No</b> : ' + typename.tc_no + '</span><span style="float:right;font_weight:bold"><b>TC OUT Date</b> : ' + typename.tcoutdate + '</span></div>';
		}

		this.printStr += '<table width="100%" border="0" cellspacing="0" cellpadding="5px" class="txt10"><thead class="thstk"><tr>';
		this.printStr += '<th class="thead" style="width:8em">QTY</th><th class="thead" style="width:25em">MACHINE NAME</th><th class="thead" style="width:25em">SERIAL NUMBER</th><th class="thead" style="width:20em" colspan="2">AMOUNT</th>';
		for (let i of typename.list) {
			this.printStr += '<tr><td style="text-align:center" class="tblbdr">' + i.quantity + '</td><td style="text-align:left" class="tblbdr">' + i.name + '</td><td style="text-align:left" class="tblbdr">' + i.serial_no + '</td></td><td class="txtalnr tblbdr" colspan="2" style="padding-right:15px">' + i.mrp + '</td></tr>';
		}
/* 		this.printStr += '<tr><td class="totbbrd"></td><td class="totbord totbbrd" colspan="2" style="padding-left:10px;padding-top:0;padding-bottom:0">Grand Total     :<span class="alnn" style="border-top:1px dashed">' + typename.amount + '</span></td></tr>';
 */		this.printStr += '</thead></table>';
 		this.printStr += '<div style="text-align:center;margin-left:4em;font-size:12px">Madurai : 98430 62988 &bull; Madurai Anna Nagar : 84899 786 79 &bull; Madurai By-Pass : 84899 786 70 &bull; Coimbatore : 84899 786 77 <br> Tirunelveli : 9786 786 006 &bull; Theni : 84899 786 16 &bull; Tirupur : 84899 786 78 &bull; Nagarcoil : 84899 786 90 &bull; Tuticorin : 84899 78620 <br> Palayamkottai : 97867 86004 &bull; Coimbatore Peelamedu : 84899 78627</div>';

		// this.printStr += '<div style="text-align:center;clear:left;padding-top:5px">Madurai : 98430 62988 - Anna Nagar : 84899 786 79 - Coimbatore : 84899 78677 - Tirunelveli : 9786 786 006</div>';
		// this.printStr += '<div style="text-align:center;margin-left:4em">Theni : 84899 786 16                - Tirupur : 84899 786 78    - Nagercoil : 84899 786 90 </div>';
		 this.printStr += '</div>';
		let orinal = this.printStr;
		$('#printContent').html(orinal);
	}



	// SERVICE ACKOWLEDMENT BILL

	generateServiceAckowledment(pageDet) {
		const details = pageDet.rows;
		const modeldet = details.modelDet;
		let branch_short_name = '';
		this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
			if (auth['islogin']) {
				branch_short_name = auth['branch_short_name'];
			}
		});

		const typename = details;
		const mobileNo = (pageDet['subTitle'] == 'Service Ackowledment' && this.usertype != 'Super_Admin' && this.usertype != 'Admin')
			? typename.disp_mobile : typename.mobile;

		const C = '#1a3a8f';
		const G = '#16a34a';

		this.printStr = '';
		this.printStr += `<div style="font-family:Arial,sans-serif;font-size:13px;color:#000;max-width:780px;margin:0 auto;padding:8px 16px;display:flex;flex-direction:column;min-height:240mm;">`;

		// Header: full-width gradient, logo left 25%, tagline top-right inside gradient
		this.printStr += `<div style="background:linear-gradient(to top,white 20%,${C} 20%,${C} 55%,forestgreen 50%,forestgreen 85%,white 80%,white 100%);margin:0 -16px;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:flex;align-items:flex-start;justify-content:space-between;">`;
		this.printStr += `<img src="assets/images/logo-white-new.png" height="100" style="width:25%;display:block;margin-left:90px;">`;
		this.printStr += `<div style="padding:0px 25px 0 0;font-size:13px;font-style:italic;color:${G};font-weight:700;">Get Your Life Back</div>`;
		this.printStr += `</div>`;

		// Branch address
		this.printStr += `<div style="text-align:right;font-size:13px;color:#333;font-weight:bold;margin:4px 0 8px 0;line-height:1.5;max-width:55%;margin-left:auto;">${typename.comp_address}</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Two-column: client info (left, padded down) | bill info (right) with HERO ELECTRONIC
		this.printStr += `<div style="display:flex;justify-content:space-between;gap:24px;margin:8px 0 10px 0;">`;
		this.printStr += `<div style="flex:1;font-size:13px;line-height:2;padding-top:30px;">`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">To Mr/Mrs</span>${typename.client_name}</div>`;
		this.printStr += `<div style="display:flex;"><span style="font-weight:bold;min-width:100px;flex-shrink:0;">Address</span><span>${typename.address}</span></div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">Mobile No</span>${mobileNo}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:100px;display:inline-block;">Client ID</span>${typename.client_no}</div>`;
		this.printStr += `</div>`;
		this.printStr += `<div style="min-width:260px;font-size:13px;line-height:1.9;">`;
		this.printStr += `<div style="font-size:22px;font-weight:900;color:#000;margin-bottom:6px;line-height:1.1;">HERO ELECTRONIC</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">GST Number</span>${typename.tinno || ''}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Service No</span>${typename.bill_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">SRF No</span>${branch_short_name} ${typename.srf_no}</div>`;
		this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Service Date</span>${typename.service_walkin_date}</div>`;
		if (parseFloat(typename.service_advance_amt) > 0) {
			this.printStr += `<div><span style="font-weight:bold;min-width:110px;display:inline-block;">Advance Amt</span>${typename.service_advance_amt}</div>`;
		}
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `<div style="border-top:2px solid ${C};margin:6px 0 10px 0;"></div>`;

		// Bill title
		this.printStr += `<div style="text-align:center;font-size:15px;font-weight:bold;color:${C};letter-spacing:2px;margin:8px 0 12px 0;">SERVICE ACKNOWLEDGEMENT</div>`;

		// Service note
		this.printStr += `<div style="text-align:center;font-weight:bold;font-size:12px;border:2px solid ${C};color:${C};padding:6px 10px;margin:8px 0 12px 0;">Service Centre No. 84899 78668 &nbsp;&bull;&nbsp; Service is valid for only 3 months</div>`;

		// Items table
		this.printStr += `<table class="sb-print-table" style="width:100%;border-collapse:collapse;font-size:13px;">`;
		this.printStr += `<thead><tr style="border-top:2px solid ${C};border-bottom:2px solid ${C};">`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;width:8%;border-left:none;">S.No</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:50%;border-left:none;">Item Description</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:left;font-weight:bold;width:30%;border-left:none;">SERIAL NO</th>`;
		this.printStr += `<th style="padding:8px 6px;text-align:center;font-weight:bold;width:12%;border-left:none;">QTY</th>`;
		this.printStr += `</tr></thead><tbody>`;

		modeldet.map((model, index) => {
			const dispName = model.display_name || model.name;
			this.printStr += `<tr>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;width:8%;border-left:none;">${index + 1}</td>`;
			this.printStr += `<td style="padding:8px 6px;width:50%;border-left:none;">${dispName}</td>`;
			this.printStr += `<td style="padding:8px 6px;width:30%;border-left:none;">${model.serial_no || ''}</td>`;
			this.printStr += `<td style="padding:8px 6px;text-align:center;width:12%;border-left:none;">${model.quantity}</td>`;
			this.printStr += `</tr>`;
		});
		this.printStr += `</tbody></table>`;

		// Terms and Conditions (left) | Signature (right)
		this.printStr += `<div style="display:flex;align-items:flex-start;margin:4px 0 10px 0;margin-top:auto;">`;
		this.printStr += `<div style="flex:1;font-size:12px;"><div style="font-weight:bold;font-size:13px;margin-bottom:4px;">Terms and Conditions</div>Service undertaken / Goods once sold cannot be taken back or exchange</div>`;
		this.printStr += `<div style="min-width:35%;text-align:center;font-size:14px;color:${C};font-weight:600;font-style:italic;">Signature</div>`;
		this.printStr += `</div>`;

		// Footer contact row
		this.printStr += `<div style="display:flex;justify-content:space-between;font-size:14px;color:#111;font-weight:600;padding:8px 0;border-top:2px solid ${C};border-bottom:2px solid ${C};margin:8px 0 4px 0;">`;
		this.printStr += `<span>hello@soundsgood.in</span>`;
		this.printStr += `<span>www.soundsgood.in</span>`;
		this.printStr += `<span>Toll Free 1800 270 196</span>`;
		this.printStr += `</div>`;

		// Branch numbers — dark navy background with white text
		this.printStr += `<div style="background:${C};font-size:10px;text-align:center;color:#fff;line-height:1.9;padding:6px 8px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">`;
		this.printStr += `<b>Madurai:</b> 98430 62988 &bull; <b>Madurai Anna Nagar:</b> 84899 78679 &bull; <b>Madurai By-Pass:</b> 84899 78670 &bull; <b>Coimbatore:</b> 84899 78677, <b>Tirunelveli:</b> 97867 86006 &bull; <b>Theni:</b> 84899 78616 &bull; <b>Tirupur:</b> 84899 78679 &bull; <b>Nagarcoil:</b> 84899 78690 &bull; <b>Tuticorin:</b> 84899 78620, <b>Palayamkottai:</b> 97867 86004 &bull; <b>Coimbatore Peelamedu:</b> 84899 78627, <b>Ramanathapuram:</b> 84899 78689`;
		this.printStr += `</div>`;
		this.printStr += `</div>`;

		this.printStr += `</div>`;

		$('#printContent').html(this.printStr);
	}
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/print/print.preview.ts